/**
 * Shared gating helpers for the 'optimize-campaign' account setting.
 *
 * The setting is a comma-separated platform list. BOTH sides of the comparison
 * (campaign destination AND each setting entry) are normalized to canonical
 * channel-type names, so admins can write the list in either convention —
 * 'g-ads-search,g-ads-pmax,g-ads-demandgen,linkedin' (the import-campaign
 * convention) or 'google-ads-search' / 'google_search' style — and both match.
 *
 * Single source of truth for CampaignGridPage and CampaignDetailPage; alias
 * knowledge added here reaches both pages (they previously carried duplicate
 * copies that could drift).
 *
 * The alias table itself now lives in accountSettingPlatformList (shared with
 * the backend mirror and every other platform-list setting) — these two
 * functions stay as named entry points for existing callers/tests.
 */
import { canonicalPlatform, isEnabledForPlatform } from './accountSettingPlatformList';
export function normalizeOptimizePlatform(value) {
  return canonicalPlatform(value);
}

export function isOptimizeCampaignEnabledFor(destination, setting) {
  return isEnabledForPlatform(setting, destination);
}

/**
 * Platforms whose campaigns.advertiser_id column holds an ACCOUNT identifier
 * (LinkedIn ad account id, Google Ads customer id) — never a campaign id.
 * The optimize flow must not fall back to advertiser_id as platformCampaignId
 * for these: doing so queries a nonexistent campaign on the platform.
 * Scoped to the platforms added with optimizer support in Jul 2026 so the
 * long-standing fallback behavior of older platforms is unchanged.
 */
export function advertiserIdIsAccountId(destination) {
  const d = normalizeOptimizePlatform(destination);
  return d === 'linkedin' || d === 'google-ads-pmax' || d === 'google-ads-demandgen';
}
